import { NgModule } from '@angular/core';

import { RtUIModule } from '@recruitee/user-interface';

import { WysiwygInlineButtonComponent } from './wysiwyg-inline-button.component';

@NgModule({
  imports: [RtUIModule],
  declarations: [WysiwygInlineButtonComponent],
  exports: [WysiwygInlineButtonComponent, RtUIModule],
})
export class WysiwygInlineButtonModule {}
